var map = {
	"./de.js": 652,
	"./fr.js": 653,
	"./nl.js": 654
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 627;



/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n ^\.\/.*\.js$
 ** module id = 627
 ** module chunks = 1
 **/